export { PurchaseResume } from '@src/features/orders/legacy/PurchaseResume';
export { getPackageDates } from '@src/features/orders/core/getPackageDates';
export { getFormattedTariffs } from '@src/features/orders/core/getFormattedTariffs';
export type {
  FormattedTariffFormatter,
  GetFormattedTariffsOptions,
} from '@src/features/orders/core/getFormattedTariffs';
export { toPurchaseSummary } from '@src/features/orders/core/toPurchaseSummary';
export { OrderStatus, type Order } from '@src/features/orders/types';
export { getOrderSaleItems, toSellerTemplateOrder } from '@src/domains/orders';
export type { SellerTemplateOrder } from '@src/domains/orders';
export { getOrderAnalyticsData } from '@src/domains/analytics';

export * from '@src/features/orders/store/order';

export { useRequiredFormInputs } from '@src/features/orders/form-inputs';
export { resolveOrderCheckoutOutcome } from '@src/features/orders/core/resolveOrderCheckoutOutcome';
export { OrderCheckoutOutcome } from '@src/features/orders/core/resolveOrderCheckoutOutcome';
export { resolveCartConfirmationOutcome } from '@src/features/orders/core/resolveCartConfirmationOutcome';
export { CartConfirmationOutcome } from '@src/features/orders/core/resolveCartConfirmationOutcome';
export { resolveOrderDetailsFooter } from '@src/features/orders/core/resolveOrderDetailsFooter';
export { OrderDetailsFooter } from '@src/features/orders/core/resolveOrderDetailsFooter';

export {
  useOrderDetails,
  useOrderDetailsHeader,
  useOrderDetailsFields,
  OrderDetailsCard,
} from '@src/features/orders/details';
export type { OrderDetailsCardProps, OrderPaymentDetails } from '@src/features/orders/details';
export { toOrderPaymentDetails } from '@src/features/orders/details/core/toOrderPaymentDetails';
export { getOrderPaymentSummary } from '@src/domains/orders';
export { ConfirmedOrderCard, useConfirmedOrder } from '@src/features/orders/confirmed-order';
export type { ConfirmedOrderCardProps } from '@src/features/orders/confirmed-order';
export { OrderSummary, useOrderSummary } from '@src/features/orders/summary';
export type { UseOrderSummaryResult } from '@src/features/orders/summary';

export { CashbackGrowthOrchestrator, CASHBACK_GROWTH_FEATURE_FLAG } from '@src/features/orders/cashback-growth';
